export default __webpack_public_path__ + "static/media/Swap-White.1865ee7b.png";